import { buildDeliveryNoteUnitOptions } from "../../utils/deliveryNoteUnits";

export function parStockUnits(form, units = []) {
  const seen = new Set();
  return buildDeliveryNoteUnitOptions(form, units).flatMap((option) => {
    const unit = units.find((entry) => String(entry.id) === String(option.unitId));
    if (!unit || seen.has(String(unit.id)) || !Number.isFinite(option.factor) || option.factor <= 0) return [];
    seen.add(String(unit.id));
    return [{ ...unit, factor: option.factor, level: option.level }];
  });
}

const resolveUnit = (unitId, units, baseUnitId) => units.find((unit) => String(unit.id) === String(unitId || baseUnitId));

export function parStockBaseQuantity(quantity, unitId, units, baseUnitId) {
  const unit = resolveUnit(unitId, units, baseUnitId);
  const value = Number(quantity);
  return unit && Number.isFinite(value) && value > 0 ? value / unit.factor : 0;
}

function target(row, units, baseUnitId, t) {
  const text = String(row?.quantity ?? "").trim();
  if (!text) return { par_quantity: null };
  const normalized = text.replace(/^\./, "0.").replace(/^0+(?=\d)/, "").replace(/\.$/, "");
  if (!/^\d{1,12}(\.\d{1,8})?$/.test(normalized) || !/[1-9]/.test(normalized)) {
    throw new Error(t("Enter a quantity greater than zero, with up to twelve integer digits and eight decimal places."));
  }
  const unit = resolveUnit(row.unit_id, units, baseUnitId);
  if (!unit) throw new Error(t("Choose one of the item's current units for this target."));
  const canonical = Number(parStockBaseQuantity(normalized, unit.id, units, baseUnitId).toFixed(8));
  if (canonical <= 0 || canonical >= 1e12) throw new Error(t("This target is outside the supported stock range in the main unit."));
  return {
    par_quantity: canonical,
    ...(unit.level !== "unit" ? { selected_quantity: normalized, unit_id: Number(unit.id) } : {}),
  };
}

export function serializeParStock(general, locations, units, baseUnitId, t = (text) => text) {
  const generalTarget = target(general, units, baseUnitId, t);
  const levels = locations.map((location) => ({
    location_id: Number(location.location_id), ...target(location, units, baseUnitId, t),
  })).filter((location) => location.par_quantity !== null);
  // Compare the intended targets before per-row storage rounding (e.g. twelve
  // one-bottle locations must fit a twelve-bottle general target in boxes of 24).
  const minimum = locations.reduce((sum, location) => sum + parStockBaseQuantity(location.quantity, location.unit_id, units, baseUnitId), 0);
  const generalBase = parStockBaseQuantity(general.quantity, general.unit_id, units, baseUnitId);
  if (generalTarget.par_quantity !== null && minimum - generalBase > 1e-8) {
    throw Object.assign(new Error(t("General par stock cannot be less than the sum of location targets.")), { minimumGeneralParQuantity: minimum });
  }
  return {
    general_par_quantity: generalTarget.par_quantity,
    ...(generalTarget.unit_id ? {
      general_selected_quantity: generalTarget.selected_quantity,
      general_unit_id: generalTarget.unit_id,
    } : {}),
    location_par_levels: levels,
  };
}
